import { svc_fetchAll, svc_editOne, svc_search } from "@/services";
import { svc_addStock, svc_getTotals } from "@/services/inventorystock";
import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "inventory/stock";

const Model = {
	namespace: "m_InventoryStock",
	state: {
		InventoryStock: [],
		InventoryTotals : [],
	},
	reducers: {
		updateModelState(state, { payload: { response } }) {
			return { ...state, InventoryStock: response };
		},
		updateTotalState(state, { payload: { response } }){
			return { ...state, InventoryTotals: response};
		}
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			// The variable name response will be passed on to payload later
			const response = yield call(svc_search, endpointBasePrefix, payload);
			// if response was not a success code, exit and don't update anything.
			if (!showServerResponse(response, false)) return;

			_.forEach(response, function (row) {
				row.key = row.id;
			});
			yield put({
				type: "updateModelState",
				payload: { response },
			})

			return response
		},

		*fetchOutlet({ payload }, { call, put }) {
			// The variable name response will be passed on to payload later
			const response = yield call(svc_search, `${endpointBasePrefix}/outlet`, payload);
			// if response was not a success code, exit and don't update anything.
			if (!showServerResponse(response, false)) return;

			_.forEach(response, function (row) {
				row.key = row.id;
			});
			yield put({
				type: "updateModelState",
				payload: { response },
			})

			return response
		},

		*fetchTotals({ payload }, { call, put }){
			const response = yield call(svc_getTotals, payload);
			// if response was not a success code, exit and don't update anything.
			if (!showServerResponse(response, false)) return;

			_.forEach(response, function (row) {
				row.key = row.id;
			});
			yield put({
				type: "updateTotalState",
				payload: { response },
			})
		},

		*addStock({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addStock, payload);
			return showServerResponse(response);
		},

		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},

	},
	subscriptions: {
		// setup({ dispatch, history }) {
		// 	return history.listen(({ pathname, query }) => {
		// 		if (pathname === "/menu" || pathname === "/brands") {
		// 			dispatch({ type: "fetchAll", payload: query });
		// 		}
		// 	});
		// },
	},
};

export default Model;
